var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.SelectCopyContent"),
        width: _vm.$selectByLang(
          "500px",
          "584px",
          "584px",
          "784px",
          "784px",
          "784px"
        ),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.source === "COST_PLAN"
        ? _c("div", [
            _c("fieldset", [
              _c("legend", [_vm._v(_vm._s(_vm.$t("Message.CopyContent")))]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "padding-left": "30px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "BusinessType" },
                      model: {
                        value: _vm.costPlan.lob,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "lob", $$v)
                        },
                        expression: "costPlan.lob"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "PlanDescription" },
                      model: {
                        value: _vm.costPlan.remark,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "remark", $$v)
                        },
                        expression: "costPlan.remark"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PlanDescription")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "DestinationPort" },
                      model: {
                        value: _vm.costPlan.pod,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "pod", $$v)
                        },
                        expression: "costPlan.pod"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DestinationPort")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "BookingAgent" },
                      model: {
                        value: _vm.costPlan.bookingAgent,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "bookingAgent", $$v)
                        },
                        expression: "costPlan.bookingAgent"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BookingAgent")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "padding-left": "30px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "ProductName" },
                      model: {
                        value: _vm.costPlan.name,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "name", $$v)
                        },
                        expression: "costPlan.name"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ProductName")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "EffectiveDate" },
                      model: {
                        value: _vm.costPlan.effectiveDate,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "effectiveDate", $$v)
                        },
                        expression: "costPlan.effectiveDate"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EffectiveDate")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "OverseaWarehouse" },
                      model: {
                        value: _vm.costPlan.overseaWarehouse,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "overseaWarehouse", $$v)
                        },
                        expression: "costPlan.overseaWarehouse"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.$selectByLang("", "width: 85px;") +
                            "display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;line-height: normal;"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_OverseaWarehouse"))
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "ShippingRouteArea" },
                      model: {
                        value: _vm.costPlan.sa,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "sa", $$v)
                        },
                        expression: "costPlan.sa"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShippingRouteArea")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "padding-left": "30px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "Department" },
                      model: {
                        value: _vm.costPlan.department,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "department", $$v)
                        },
                        expression: "costPlan.department"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Department")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "InvalidDate" },
                      model: {
                        value: _vm.costPlan.expiryDate,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "expiryDate", $$v)
                        },
                        expression: "costPlan.expiryDate"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InvalidDate")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "HSCode" },
                      model: {
                        value: _vm.costPlan.hsCode,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "hsCode", $$v)
                        },
                        expression: "costPlan.hsCode"
                      }
                    },
                    [_vm._v(_vm._s("HSCode"))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "DestinationAgent" },
                      model: {
                        value: _vm.costPlan.destinationAgent,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "destinationAgent", $$v)
                        },
                        expression: "costPlan.destinationAgent"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DestinationAgent")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "padding-left": "30px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "TypeOfGoods" },
                      model: {
                        value: _vm.costPlan.cargoType,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "cargoType", $$v)
                        },
                        expression: "costPlan.cargoType"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TypeOfGoods")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "ChargeDetails" },
                      model: {
                        value: _vm.costPlan.chargeDetail,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "chargeDetail", $$v)
                        },
                        expression: "costPlan.chargeDetail"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ChargeDetails")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "AuthorizedClient" },
                      model: {
                        value: _vm.costPlan.customer,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "customer", $$v)
                        },
                        expression: "costPlan.customer"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AuthorizedClient")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "AvailableBranch" },
                      model: {
                        value: _vm.costPlan.availableBranch,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "availableBranch", $$v)
                        },
                        expression: "costPlan.availableBranch"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AvailableBranch")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "padding-left": "30px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "FLCLType" },
                      model: {
                        value: _vm.costPlan.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "containerLoadType", $$v)
                        },
                        expression: "costPlan.containerLoadType"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FLCLType")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "PortOfLoading" },
                      model: {
                        value: _vm.costPlan.pol,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "pol", $$v)
                        },
                        expression: "costPlan.pol"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PortOfLoading")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "Carrier" },
                      model: {
                        value: _vm.costPlan.carrier,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "carrier", $$v)
                        },
                        expression: "costPlan.carrier"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Carrier")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "User" },
                      model: {
                        value: _vm.costPlan.user,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "user", $$v)
                        },
                        expression: "costPlan.user"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_User")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "padding-left": "30px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "exchangeAgent" },
                      model: {
                        value: _vm.costPlan.exchangeAgent,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "exchangeAgent", $$v)
                        },
                        expression: "costPlan.exchangeAgent"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BillExchangeAgent")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      style: _vm.$selectByLang(
                        "width: 64px",
                        "width: 85px",
                        "width: 140px",
                        "width: 140px",
                        "width: 140px"
                      ),
                      attrs: { no: "designationAgent" },
                      model: {
                        value: _vm.costPlan.designationAgent,
                        callback: function($$v) {
                          _vm.$set(_vm.costPlan, "designationAgent", $$v)
                        },
                        expression: "costPlan.designationAgent"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NominatedAgent")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-checkbox",
                  {
                    staticStyle: {
                      "margin-top": "8px",
                      "margin-bottom": "8px",
                      "word-wrap": "break-word",
                      "white-space": "normal",
                      "word-break": "normal",
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "center"
                    },
                    attrs: { no: "TimeAfterSelecting" },
                    model: {
                      value: _vm.rmb,
                      callback: function($$v) {
                        _vm.rmb = $$v
                      },
                      expression: "rmb"
                    }
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SeaExport.ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft"
                          )
                        )
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "word-wrap": "break-word",
                  "white-space": "normal",
                  "font-family": "sans-serif",
                  "margin-bottom": "8px",
                  "margin-left": "24px"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "10px",
                      color: "#8c939d",
                      "line-height": "18px"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "SeaExport.ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight"
                        )
                      )
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCopyNumber,
                    expression: "showCopyNumber"
                  }
                ],
                staticStyle: {
                  "margin-left": "24px",
                  "font-size": "12px",
                  "-webkit-font-smoothing": "antialiased",
                  "text-rendering": "optimizeLegibility",
                  "font-family":
                    "Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif"
                }
              },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("Message.CopyNumber")))]),
                _c("el-input-number", {
                  staticStyle: { width: "100px" },
                  attrs: {
                    no: "CopyNumber",
                    value: _vm.costPlan.copyNum,
                    precision: 0,
                    min: 1,
                    max: 100,
                    "controls-position": "right"
                  },
                  on: { input: _vm.numFunction }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }